import * as LogRocket from "logrocket"
// @ts-ignore
import createPlugin from "logrocket-vuex"
import {appConfig} from "@/config/app.config"
import logging from "@/utils/logging"

const Tracker = {
    init() {
        // Initialize LogRocket
        if (!appConfig.IS_DEBUG) {
            LogRocket.init(appConfig.TRACKING.LOG_ROCKET_APP_ID, {
                release: appConfig.VERSION,
                console: {shouldAggregateConsoleErrors: true},
            })
        }
    },
    setUserId(userId: string) {
        LogRocket.identify(userId, {})
    },
    clearUser() {
        LogRocket.startNewSession()
    },
    track(eventName: string) {
        logging.debug("Tracking new event:", eventName)
        LogRocket.track(eventName)
    },
    plugin: createPlugin(LogRocket),
}

export default Tracker
